<!-- 热切图 -->
<template>
  <div class="wh__cut-image-wrapper">
    <div class="cut-image-div">
      <img :src="$cvWebpFn(props.data.image)" class="cur-img" :lazy="useImgLazy().value" />

      <div
        v-for="(item, index) in props.data.item"
        :key="index"
        :style="get_location_fn(item, index)" 
        class="cut_click_item"
        @click="handleClick(item)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { buildStoreHomeListingSource, resolveStoreHomeSourceValue } from '@/plugins/utils'

const { $cmsStoreJump } = useNuxtApp()

const props = defineProps<{ data: IStore.ICutImage, storeId: number }>()
const route = useRoute()

const cmsSource = computed(() =>
  buildStoreHomeListingSource(
    resolveStoreHomeSourceValue('cutImage', { checked_name: props.data.checked_name }),
    undefined,
    route
  )
)

const get_location_fn = computed(() => {
  return (item: any, index: number) => {
    return {
      width: item.location[0],
      height: item.location[1],
      left: item.location[2],
      top: item.location[3],
      borderRadius: item.radius,
      zIndex: 10 + index
    }
  }
})

const handleClick = (item: any) => {
  const { type, data } = item
  
  $cmsStoreJump(
    type,
    data,
    {
      storeId: props.storeId,
      source: cmsSource.value
    }
  )
}
</script>

<style lang='scss' scoped>
.wh__cut-image-wrapper{
  overflow: hidden;
  border-radius: 10px;
}
.cut-image-div {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  border-radius: 10px;
  .cur-img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  
  .cut_click_item {
    opacity: 0;
    overflow: hidden;
    display: block;
    position: absolute;
    background-color: rgba(255,255,255,0.2);
  }
}
</style>